/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalendarEvent } from './CalendarEvent';
import {
    CalendarEventFromJSON,
    CalendarEventFromJSONTyped,
    CalendarEventToJSON,
    CalendarEventToJSONTyped,
} from './CalendarEvent';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TeacherCalendar
 */
export interface TeacherCalendar {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TeacherCalendar
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof TeacherCalendar
     */
    calendarId: string;
    /**
     * 
     * @type {Date}
     * @memberof TeacherCalendar
     */
    fromDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof TeacherCalendar
     */
    toDate: Date;
    /**
     * 
     * @type {Array<CalendarEvent>}
     * @memberof TeacherCalendar
     */
    events: Array<CalendarEvent>;
}

/**
 * Check if a given object implements the TeacherCalendar interface.
 */
export function instanceOfTeacherCalendar(value: object): value is TeacherCalendar {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('calendarId' in value) || value['calendarId'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    return true;
}

export function TeacherCalendarFromJSON(json: any): TeacherCalendar {
    return TeacherCalendarFromJSONTyped(json, false);
}

export function TeacherCalendarFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeacherCalendar {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'calendarId': json['calendarId'],
        'fromDate': (new Date(json['fromDate'])),
        'toDate': (new Date(json['toDate'])),
        'events': ((json['events'] as Array<any>).map(CalendarEventFromJSON)),
    };
}

export function TeacherCalendarToJSON(json: any): TeacherCalendar {
    return TeacherCalendarToJSONTyped(json, false);
}

export function TeacherCalendarToJSONTyped(value?: TeacherCalendar | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'calendarId': value['calendarId'],
        'fromDate': value['fromDate'].toISOString().substring(0,10),
        'toDate': value['toDate'].toISOString().substring(0,10),
        'events': ((value['events'] as Array<any>).map(CalendarEventToJSON)),
    };
}

